import React from "react";
import { Route, Navigate } from "react-router-dom";
import { all_routes } from "./all_routes";

// Dashboard
import Dashboard from "../feature-module/dashboard/Dashboard";

// Authentication
import SigninTwo from "../feature-module/pages/login/signinTwo";
import ForgotpasswordTwo from "../feature-module/pages/forgotpassword/forgotpasswordTwo";
import Resetpassword from "../feature-module/pages/resetpassword/resetpassword";
import VerifyOtp from "../feature-module/pages/verifyotp/verifyotp";

// Products
import UomList from "../pages/products/uom/uom-list";
import UomForm from "../pages/products/uom/uom-form";
import CategoryList from "../pages/products/categories/category-list";
import CategoryForm from "../pages/products/categories/category-form";
import BrandList from "../pages/products/brands/brand-list";
import BrandForm from "../pages/products/brands/brand-form";
import ProductList from "../pages/products/product/product-list";
import ProductForm from "../pages/products/product/product-form";
import ProductDetails from "../pages/products/product/product-details";
import ProductFromCatalog from "../pages/products/product/product-from-catalog";
import ProductImageDetails from "../pages/products/product/product-Image-detail";
import CatalogList from "../pages/products/catalog/catalog-list";
import CatalogForm from "../pages/products/catalog/catalog-form";
import CatalogDetails from "../pages/products/catalog/catalog-details";
import CatalogImageDetails from "../pages/products/catalog/catalog-images-detail";
import ObjectUpload from "../pages/products/catalog/object-upload";
import PledgePriceList from "../pages/products/pledge-price/pledge-price-list";
import PledgePriceForm from "../pages/products/pledge-price/pledge-price-form";
import LiveStream from "../pages/products/LiveStream";

// People Management
import CompanyList from "../pages/people/companies/company-list";
import CompanyForm from "../pages/people/companies/company-form";
import CompanyDetail from "../pages/people/companies/company-detail";
import EmployeeList from "../pages/people/employee/employee-list.jsx";
import EmployeesForm from "../pages/people/employee/employee-form.jsx";
import EmployeeDetails from "../pages/people/employee/employee-detail.jsx";
import DesignationList from "../pages/people/designations/designation-list.jsx";
import ShoppersList from "../pages/people/shoppers/shoppers-list";
import ShoppersDetails from "../pages/people/shoppers/shoppers-details";
import ShopperCreate from "../pages/people/shoppers/shopper-form";

// Stores Management
import OutletsList from "../pages/stores/outlets/outlets-list";
import OutletsForm from "../pages/stores/outlets/outlets-form";
import OutletsDetails from "../pages/stores/outlets/outlets-details";
import { OutletLayout } from "../pages/stores/outlets/outlet-layout";
import ShelfManagementView from "../pages/stores/outlets/shelf-management/view.jsx";
import OutletLogsList from "../pages/stores/outlet-logs/outlet-logs-list";
import CCTVList from "../pages/stores/cctv/cctv-list";
import CCTVForm from "../pages/stores/cctv/cctv-form";

// Inventory
import OutletStockList from "../pages/inventory/outletstock/outlet-stock-list";

// Sales
import SalesList from "../pages/Sales/Sales/sales-list";
import SalesDetails from "../pages/Sales/Sales/sales-details";

// User Management
import UserList from "../pages/user-managment/user/user-list";
import UserForm from "../pages/user-managment/user/user-form";
import RoleList from "../pages/user-managment/role/role-list";
import RoleForm from "../pages/user-managment/role/role-form";

// Settings
import SystemLanguageList from "../pages/settings/system-language/system-language-list";
import UpdateLanguageJson from "../pages/settings/system-language/language-json-upload";
import CountryList from "../pages/settings/country/country-list";
import CountryForm from "../pages/settings/country/country-form";
import CountryDetails from "../pages/settings/country/country-details";
import NotificationList from "../pages/settings/notification/notification-list";
import NotificationForm from "../pages/settings/notification/notification-form";
import FaqList from "../pages/settings/faq/faq-list";
import FaqTranslation from "../pages/settings/faq/faq-translations";
import FaqTypeList from "../pages/settings/faq-type/faq-type-list";
import FaqTypeTranslations from "../pages/settings/faq-type/faq-type-translations";
import LogsList from "../pages/settings/backend-logs/logs-list";
import UpdateAppSettings from "../pages/settings/settings-update/update-app-setting.jsx";

// Support
import TicketList from "../pages/support/contact/ticket-list";
import TicketDetails from "../pages/support/contact/ticket-details";

// Profile
import MyProfile from "../pages/profile/my-profile/profile";

// Third Party
import ThirdPartyList from "../pages/thirdParty/thirdParty/thirdParty-list";

// Sample Pages
import ThreedFilePage from "../pages/sample/3d-file";
import ThreedFileWindowIphoneExpanded from "../pages/sample/sample-iphone/3d-window-expanded";

const routes = all_routes;

export const privateRoutes = [
  // Dashboard
  {
    id: 1,
    path: routes.dashboard,
    name: "home",
    element: <Dashboard />,
    perm: "exempt",
    route: Route,
  },

  // Products Management
  {
    id: 5,
    path: routes.brandlist,
    name: "brand",
    element: <BrandList />,
    perm: "brand-view",
    route: Route,
  },
  {
    id: 6,
    path: routes.brandcreate,
    name: "brand-create",
    element: <BrandForm />,
    perm: "brand-add",
    route: Route,
  },
  {
    id: 7,
    path: routes.brandedit,
    name: "brand-edit",
    element: <BrandForm />,
    perm: "brand-edit",
    route: Route,
  },
  {
    id: 8,
    path: routes.categorylist,
    name: "category-list",
    element: <CategoryList />,
    perm: "category-view",
    route: Route,
  },
  {
    id: 9,
    path: routes.categoryCreate,
    name: "category-create",
    element: <CategoryForm />,
    perm: "category-add",
    route: Route,
  },
  {
    id: 10,
    path: routes.categoryEdit,
    name: "category-edit",
    element: <CategoryForm />,
    perm: "category-edit",
    route: Route,
  },
  {
    id: 11,
    path: routes.uomList,
    name: "uom-list",
    element: <UomList />,
    perm: "uom-view",
    route: Route,
  },
  {
    id: 12,
    path: routes.uomCreate,
    name: "uom-create",
    element: <UomForm />,
    perm: "uom-add",
    route: Route,
  },
  {
    id: 13,
    path: routes.uomEdit,
    name: "uom-edit",
    element: <UomForm />,
    perm: "uom-edit",
    route: Route,
  },
  {
    id: 14,
    path: routes.productList,
    name: "product-list",
    element: <ProductList />,
    perm: "product-view",
    route: Route,
  },
  {
    id: 15,
    path: routes.productCreate,
    name: "product-create",
    element: <ProductForm />,
    perm: "product-add",
    route: Route,
  },
  {
    id: 16,
    path: routes.productEdit,
    name: "product-edit",
    element: <ProductForm />,
    perm: "product-edit",
    route: Route,
  },
  {
    id: 17,
    path: routes.productDetails,
    name: "product-details",
    element: <ProductDetails />,
    perm: "product-view",
    route: Route,
  },
  {
    id: 19,
    path: routes.productImageDetails,
    name: "product/image-details",
    element: <ProductImageDetails />,
    perm: "product-view",
    route: Route,
  },
  {
    id: 24,
    path: routes.catalogImageDetails,
    name: "catalog/image-details",
    element: <CatalogImageDetails />,
    perm: "catalog-view",
    route: Route,
  },
  

  // People Management
  {
    id: 30,
    path: routes.companiesList,
    name: "company-list",
    element: <CompanyList />,
    perm: "company-view",
    route: Route,
  },
  {
    id: 31,
    path: routes.companyCreate,
    name: "company-create",
    element: <CompanyForm />,
    perm: "company-add",
    route: Route,
  },
  {
    id: 32,
    path: routes.companyEdit,
    name: "company-edit",
    element: <CompanyForm />,
    perm: "company-edit",
    route: Route,
  },
  {
    id: 33,
    path: routes.companyDetails,
    name: "company-detail",
    element: <CompanyDetail />,
    perm: "exempt",
    route: Route,
  },
  {
    id: 34,
    path: routes.employeesList,
    name: "employee-list",
    element: <EmployeeList />,
    perm: "employee-view",
  },
  {
    id: 35,
    path: routes.employeesCreate,
    name: "employees-create",
    element: <EmployeesForm />,
    perm: "employee-add",
    route: Route,
  },
  {
    id: 36,
    path: routes.employeesEdit,
    name: "employees-edit",
    element: <EmployeesForm />,
    perm: "employee-edit",
    route: Route,
  },
  {
    id: 37,
    path: routes.employeesDetails,
    name: "employee-details",
    element: <EmployeeDetails />,
    perm: "employee-view",
  },
  {
    id: 38,
    path: routes.designationList,
    name: "designation-list",
    element: <DesignationList />,
    perm: "designation-view",
  },
  {
    id: 39,
    path: routes.shoppersList,
    name: "shoppers-list",
    element: <ShoppersList />,
    perm: "shopper-view",
    route: Route,
  },
  {
    id: 40,
    path: routes.shopperCreate,
    name: "shopper-create",
    element: <ShopperCreate />,
    perm: "shopper-add",
    route: Route,
  },
  {
    id: 41,
    path: routes.ShoppersEdit,
    name: "shopper-edit",
    element: <ShopperCreate />,
    perm: "shopper-edit",
    route: Route,
  },
  {
    id: 42,
    path: routes.ShoppersDetails,
    name: "shoppers-details",
    element: <ShoppersDetails />,
    perm: "exempt",
    route: Route,
  },

  // Stores Management
  {
    id: 43,
    path: routes.outletsList,
    name: "outlets-list",
    element: <OutletsList />,
    perm: "shop-view",
    route: Route,
  },
  {
    id: 44,
    path: routes.outletsCreate,
    name: "outlets-create",
    element: <OutletsForm />,
    perm: "shop-add",
    route: Route,
  },
  {
    id: 45,
    path: routes.outletsEdit,
    name: "outlets-edit",
    element: <OutletsForm />,
    perm: "shop-edit",
    route: Route,
  },
  {
    id: 46,
    path: routes.outletsDetails,
    name: "outlets-details",
    element: <OutletsDetails />,
    perm: "shop-view",
    route: Route,
  },
  {
    id: 47,
    path: routes.outletsLayout,
    name: "outlets-layout",
    element: <OutletLayout />,
    perm: "shelf-management-edit",
    route: Route,
  },
  {
    id: 48,
    path: routes.shelfManagementView,
    name: "shelf-management-view",
    element: <ShelfManagementView />,
    perm: "shelf-management-view",
    route: Route,
  },
  {
    id: 49,
    path: routes.outletLogsList,
    name: "outlet-logs-list",
    element: <OutletLogsList />,
    perm: "shop-view",
    route: Route,
  },
  {
    id: 50,
    path: routes.cctvList,
    name: "cctv-list",
    element: <CCTVList />,
    perm: "shop-view",
    route: Route,
  },
  {
    id: 51,
    path: routes.cctvcreate,
    name: "cctv-create",
    element: <CCTVForm />,
    perm: "shop-add",
    route: Route,
  },
  {
    id: 52,
    path: routes.cctvedit,
    name: "cctv-edit",
    element: <CCTVForm />,
    perm: "shop-edit",
    route: Route,
  },


  // Sales
  {
    id: 54,
    path: routes.salesList,
    name: "sales-list",
    element: <SalesList />,
    perm: "sale-view",
    route: Route,
  },
  {
    id: 55,
    path: routes.salesDetails,
    name: "sales-details",
    element: <SalesDetails />,
    perm: "sale-view",
    route: Route,
  },

  // User Management
  {
    id: 56,
    path: routes.userList,
    name: "user-list",
    element: <UserList />,
    perm: "user-view",
    route: Route,
  },
  {
    id: 57,
    path: routes.userCreate,
    name: "user-create",
    element: <UserForm />,
    perm: "user-add",
    route: Route,
  },
  {
    id: 58,
    path: routes.userEdit,
    name: "user-edit",
    element: <UserForm />,
    perm: "user-edit",
    route: Route,
  },
  {
    id: 59,
    path: routes.roleList,
    name: "role-list",
    element: <RoleList />,
    perm: "role-view",
    route: Route,
  },
  {
    id: 60,
    path: routes.roleCreate,
    name: "role-create",
    element: <RoleForm />,
    perm: "role-add",
    route: Route,
  },
  {
    id: 61,
    path: routes.roleEdit,
    name: "role-edit",
    element: <RoleForm />,
    perm: "role-edit",
    route: Route,
  },

  // Settings
  {
    id: 62,
    path: routes.systemLanguageList,
    name: "system-language-list",
    element: <SystemLanguageList />,
    perm: "language-view",
    route: Route,
  },
  {
    id: 63,
    path: routes.systemLanguageJson,
    name: "system-language-Json",
    element: <UpdateLanguageJson />,
    perm: "json-translation-create",
    route: Route,
  },
  {
    id: 64,
    path: routes.CountryList,
    name: "country-list",
    element: <CountryList />,
    perm: "country-view",
    route: Route,
  },
  {
    id: 65,
    path: routes.CountryCreate,
    name: "country-create",
    element: <CountryForm />,
    perm: "country-add",
    route: Route,
  },
  {
    id: 66,
    path: routes.CountryEdit,
    name: "country-edit",
    element: <CountryForm />,
    perm: "country-edit",
    route: Route,
  },
  {
    id: 67,
    path: routes.CountryDetails,
    name: "country-details",
    element: <CountryDetails />,
    perm: "country-view",
    route: Route,
  },
  {
    id: 71,
    path: routes.FaqList,
    name: "faq-list",
    element: <FaqList />,
    perm: "faq-view",
    route: Route,
  },
  {
    id: 72,
    path: routes.faqTranslations,
    name: "faq-translations",
    element: <FaqTranslation />,
    perm: "faq-view",
    route: Route,
  },
  {
    id: 73,
    path: routes.FaqTypeList,
    name: "faq-type-list",
    element: <FaqTypeList />,
    perm: "faq-type-view",
    route: Route,
  },
  {
    id: 74,
    path: routes.faqTypeTranslations,
    name: "faq-type-translations",
    element: <FaqTypeTranslations />,
    perm: "faq-type-view",
    route: Route,
  },
  {
    id: 75,
    path: routes.logList,
    name: "logs-list",
    element: <LogsList />,
    perm: "log-view",
    route: Route,
  },
  {
    id: 76,
    path: routes.updateAppSettings,
    name: "update-app-settings",
    element: <UpdateAppSettings />,
    perm: "exempt",
    route: Route,
  },

  // Support
  {
    id: 77,
    path: routes.ticketList,
    name: "ticket-list",
    element: <TicketList />,
    perm: "ticket-view",
    route: Route,
  },
  {
    id: 78,
    path: routes.ticketDetails,
    name: "ticket-details",
    element: <TicketDetails />,
    perm: "ticket-view",
    route: Route,
  },

  // Profile
  {
    id: 79,
    path: routes.myProfile,
    name: "my-profile",
    element: <MyProfile />,
    perm: "exempt",
    route: Route,
  },

  // Third Party
  {
    id: 80,
    path: all_routes.thirdPartyList,
    name: "third-party-list",
    element: <ThirdPartyList />,
    perm: "third-party-view",
    route: Route,
  },

  // Sample Pages
  {
    id: 81,
    path: "3d-sample",
    name: "3d-sample",
    element: <ThreedFilePage />,
    perm: "exempt",
    route: Route,
  },

  // Navigation Routes
  {
    id: 83,
    path: "/",
    name: "Root",
    element: <Navigate to="/" />,
    perm: "exempt",
    route: Route,
  },
  {
    id: 84,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/" />,
    perm: "exempt",
    route: Route,
  },
];

export const pagesRoute = [
  {
    id: 1,
    path: routes.signintwo,
    name: "signintwo",
    element: <SigninTwo />,
    route: Route,
  },
  {
    id: 2,
    path: routes.forgotPasswordTwo,
    name: "forgotPasswordTwo",
    element: <ForgotpasswordTwo />,
    route: Route,
  },
  {
    id: 3,
    path: routes.verifyOtp,
    name: "verifyotp",
    element: <VerifyOtp />,
    route: Route,
  },
  {
    id: 4,
    path: routes.resetpassword,
    name: "resetpassword",
    element: <Resetpassword />,
    route: Route,
  },
];